import { useNextT } from "../i18n";
import { useImportRunning } from "../bridges/frame";
import { Icon } from "./icons";
import s from "./ImportStatus.module.scss";

/** Shown under the logo while an import runs. */
export const ImportStatus = () => {
  const { t } = useNextT();
  if (!useImportRunning()) return null;
  return <span role="status" className={s.importing}><Icon name="spinner" size={16} className={s.spin} />{t("shell.top.importing")}</span>;
};
